import { render, staticRenderFns } from "./DeepLinks.vue?vue&type=template&id=39033f98"
import script from "./DeepLinks.vue?vue&type=script&lang=js"
export * from "./DeepLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports